export const TICKET_ACTIVITIES_RESET_STATE = 'TICKET_ACTIVITIES_RESET_STATE';
export const TICKET_ACTIVITIES_CURRENT_ITEM = 'TICKET_ACTIVITIES_CURRENT_ITEM';

export const TICKET_ACTIVITIES_REQUEST_LOADING = 'TICKET_ACTIVITIES_REQUEST_LOADING';
export const TICKET_ACTIVITIES_REQUEST_SUCCESS = 'TICKET_ACTIVITIES_REQUEST_SUCCESS';
export const TICKET_ACTIVITIES_REQUEST_FAILED = 'TICKET_ACTIVITIES_REQUEST_FAILED';

export const TICKET_ACTIVITIES_CURRENT_ACTION = 'TICKET_ACTIVITIES_CURRENT_ACTION';
export const TICKET_ACTIVITIES_RESET_ACTION = 'TICKET_ACTIVITIES_RESET_ACTION';
